// Create application restrictions
const INST_MAX_FILES_PER_DROP = 10
const INST_MIN_FILE_SIZE_BYTES = 0
const INST_MAX_FILE_SIZE_BYTES = 1024 * 1024 * 4 // 4MB

// Publish new LCT / TTR restrictions
const DEVICE_MAX_ALLOWED_ATTACHMENTS = 10
const DEVICE_MAX_FILES_PER_DROP = DEVICE_MAX_ALLOWED_ATTACHMENTS
const DEVICE_MIN_FILE_SIZE_BYTES = 0
const DEVICE_MAX_FILE_SIZE_BYTES = 1024 * 1024 * 25 // 25MB

export {
    DEVICE_MAX_ALLOWED_ATTACHMENTS,
    DEVICE_MAX_FILES_PER_DROP,
    DEVICE_MAX_FILE_SIZE_BYTES,
    DEVICE_MIN_FILE_SIZE_BYTES,
    INST_MAX_FILES_PER_DROP,
    INST_MAX_FILE_SIZE_BYTES,
    INST_MIN_FILE_SIZE_BYTES,
}
